<hlm-sidebar collapsible="none" class="border-r border-border">
  <!-- Header with logo -->
  <hlm-sidebar-header>
    <button
      type="button"
      data-tour="sidebar-logo"
      class="flex items-center gap-3 px-2 py-2 rounded-[0.5rem] hover:bg-accent cursor-pointer transition-colors w-full text-left"
      (click)="openWelcome()"
    >
      <img src="assets/logo-small.png" alt="Pagai" class="h-8 w-8" />
      <span class="text-lg font-semibold text-foreground">Pagai</span>
    </button>

    <!-- Tenant Selector: Only visible for Labor Consultants with multiple tenants -->
    @if (isLaborConsultant() && hasMultipleTenants()) {
      <div data-tour="sidebar-tenant" class="flex items-center gap-2 px-2 pb-2">
        <!-- Tenant Avatar -->
        <hlm-avatar class="h-9 w-9 shrink-0">
          @if (selectedTenant()?.logoS3Key) {
            <img
              hlmAvatarImage
              [src]="selectedTenant()?.logoS3Key"
              [alt]="selectedTenant()?.businessName"
            />
          }
          <span hlmAvatarFallback class="bg-primary/10 text-primary text-sm font-medium">
            {{ tenantInitials() }}
          </span>
        </hlm-avatar>

        <!-- Tenant Business Name -->
        <span class="flex-1 truncate text-sm font-medium text-foreground">
          {{ selectedTenant()?.businessName ?? 'Seleziona azienda' }}
        </span>

        <!-- Switch Tenant Button -->
        <button
          type="button"
          hlmBtn
          variant="ghost"
          size="icon"
          class="h-8 w-8 shrink-0"
          (click)="openTenantDialog()"
        >
          <ng-icon name="lucideChevronsUpDown" class="h-4 w-4" />
        </button>
      </div>
    }
  </hlm-sidebar-header>

  <!-- Navigation content -->
  <div hlmSidebarContent>
    <div hlmSidebarGroup>
      <div hlmSidebarGroupContent>
        <ul data-tour="sidebar-nav" hlmSidebarMenu>
          @for (item of items(); track item.id) {
            <li hlmSidebarMenuItem [attr.data-tour]="'nav-' + item.id">
              <a
                hlmSidebarMenuButton
                [routerLink]="item.path"
                routerLinkActive="active"
                [isActive]="isActive(item.path)"
              >
                <ng-icon [name]="item.icon" />
                <span>{{ item.label }}</span>
              </a>
            </li>
          }
        </ul>
      </div>
    </div>
  </div>

  <!-- Footer: avatar + name on the left, kebab menu on the right.
       Menu items (top to bottom): Impostazioni, Supporto, Esci. -->
  <hlm-sidebar-footer>
    <button
      type="button"
      data-tour="sidebar-user"
      class="flex w-full items-center gap-2 p-2 rounded-[0.5rem] text-left text-sm text-sidebar-foreground hover:bg-sidebar-accent hover:text-sidebar-accent-foreground transition-colors cursor-pointer focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-sidebar-ring"
      aria-label="Apri menu utente"
      [hlmDropdownMenuTrigger]="userMenu"
      align="end"
      side="top"
    >
      <hlm-avatar class="h-9 w-9 shrink-0">
        <span hlmAvatarFallback class="bg-primary/10 text-primary text-sm font-medium">
          {{ userInitials() }}
        </span>
      </hlm-avatar>
      <span class="flex-1 min-w-0 font-medium truncate">
        {{ userName() }}
      </span>
      <ng-icon name="lucideEllipsisVertical" class="h-4 w-4 shrink-0" />
    </button>
  </hlm-sidebar-footer>

  <ng-template #userMenu>
    <div hlmDropdownMenu class="min-w-[10rem]">
      <button type="button" hlmDropdownMenuItem (click)="goToSettings()">
        <ng-icon name="lucideSettings" class="mr-2 h-4 w-4" />
        Impostazioni
      </button>
      <button type="button" hlmDropdownMenuItem (click)="openHelp()">
        <ng-icon name="lucideMessageCircleQuestion" class="mr-2 h-4 w-4" />
        Supporto
      </button>
      <button type="button" hlmDropdownMenuItem (click)="logout()">
        <ng-icon name="lucideLogOut" class="mr-2 h-4 w-4" />
        Esci
      </button>
    </div>
  </ng-template>
</hlm-sidebar>

<!-- Tenant selector dialog for Labor Consultants -->
<app-tenant-selector-dialog #tenantDialog />

<!-- Logout confirmation dialog -->
<hlm-alert-dialog
  [state]="logoutDialogOpen() ? 'open' : 'closed'"
  (stateChanged)="onLogoutDialogStateChange($event)"
>
  <div hlmAlertDialogContent *brnAlertDialogContent="let ctx">
    <div hlmAlertDialogHeader>
      <h3 hlmAlertDialogTitle>Esci da Pagai</h3>
      <p hlmAlertDialogDescription>
        Sei sicuro di voler uscire? Dovrai effettuare di nuovo l'accesso per rientrare.
      </p>
    </div>
    <div hlmAlertDialogFooter>
      <button hlmBtn variant="outline" (click)="cancelLogout()">Annulla</button>
      <button hlmBtn variant="destructive" (click)="confirmLogout()">Esci</button>
    </div>
  </div>
</hlm-alert-dialog>
<!-- Welcome dialog (opens on first access via TutorialService signal) -->
<app-welcome-dialog />

<!-- Tutorial picker dialog (opens via sidebar Tutorial button) -->
<app-tutorial-picker-dialog #tutorialPicker />
